<template>
  <div class="checkbox">
    <input type="checkbox" :value="value" id="checkbox1">
    <label for="checkbox1">{{ label }}</label>
  </div>
</template>

<script>
  export default {    
    props: {
      label: {
        type: String,
        default: ""
      },
      value: {
        type: Boolean,
        default: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// checkbox.vue?e2a8f034